module.exports = __webpack_public_path__ + "static/img/logoLogin.3212e38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logoLogin.png
// module id = 178
// module chunks = 1